import { ready } from '~/core';
import { addEvents, createElement } from '~/utils';

ready('styleGuide', '.markupNav a', link => {
	addEvents(link, 'click.stop.prevent enter.stop.prevent', () => {
		let dest = link.getAttribute('href');
		window.scrollTo({
			top:
				document.querySelector(dest).getBoundingClientRect().top,
			behavior: 'smooth'
		});
	});
});

ready('gridBuilder', '.gridBuilder', builder => {
	const add = builder.querySelector('.add');
	const remove = builder.querySelector('.remove');
	const even = builder.querySelector('.even');
	const width = builder.querySelector('.width');
	const media = builder.querySelector('.media');
	const guttersDef = builder.querySelector('.gutters--def');
	const guttersSm = builder.querySelector('.gutters--sm');
	const guttersLg = builder.querySelector('.gutters--lg');
	const centered = builder.querySelector('.centered');

	const grid = builder.querySelector('.gridBuilder-grid .g');
	const code = builder.querySelector('.gridBuilder-code code');

	let is_even = even.checked;
	let columns = 4;

	const input_settings = () => {
		return {
			class: 'width',
			type: 'number',
			step: 1,
			min: 1,
			max: 12,
			value: width.value
		};
	};

	const column_settings = (overwrite = false) => {
		return {
			class: `g-c g-c--${media.value}${overwrite ? overwrite : width.value}`
		};
	};

	const make_column = () => {
		let input = createElement('input', input_settings());
		let col = createElement('div', column_settings(), input);

		input.addEventListener('input', () => do_input.apply(input, [true]));

		return col;
	};

	const make_html = () => {
		const grid_code = grid.cloneNode(true);
		grid_code.querySelectorAll('.g-c').forEach(col => {
			col.innerHTML = '';
			while (col.attributes.length > 1) {
				if (col.attributes[0].name != 'class') {
					col.removeAttribute(col.attributes[0].name);
				} else {
					col.removeAttribute(col.attributes[1].name);
				}
			}
		});
		
		code.textContent = process(grid_code.outerHTML).substring(1);
		// Typing effect, cool but unnecessary
		// code.textContent = '';
		// let chars = process(grid_code.outerHTML).split('')
		// const type = (ch) => {
		// 	return new Promise(res => {
		// 		setTimeout(() => {
		// 			code.textContent+=ch;
		// 			res();
		// 		}, 1)
		// 	})
		// }
		// chars.reduce(async (previousPromise, ch) => {
		// 	if (previousPromise == 0) return Promise.resolve()
		// 	await previousPromise
		// 	return type(ch)
		// }, 0)		
	};

	const do_reset = () => {
		code.innerText = '';
		grid.innerHTML = '';
		for (let i = 0; i < columns; i++) {
			grid.insertAdjacentElement('beforeend', make_column());
		}
		make_html();
	};

	const do_add = () => {
		columns++;
		grid.insertAdjacentElement('beforeend', make_column());
		make_html();
	};

	const do_remove = () => {
		columns--;
		grid.removeChild(grid.lastElementChild);
		make_html();
	};

	const do_input = function(col = false) {
		if (is_even) {
			builder.querySelectorAll('.width').forEach(width => (width.value = this.value));
			do_reset();
		} else if (col) {
			let col = this.closest('.g-c');
			col.setAttribute('class', column_settings(this.value).class);
			make_html();
		}
	};

	const do_media = function() {
		if (is_even) {
			do_reset();
		} else {
			grid.querySelectorAll('.g-c').forEach(col => {
				col.setAttribute('class', column_settings(col.querySelector('input').value).class);
			});
			make_html();
		}
	};
	
	const do_gutters = (size=null) => {
		grid.classList.remove('g--gutterSm', 'g--gutterLg')
		if (size) {
			grid.classList.add(`g--gutter${size}`)
		}
		make_html();
	}
	
	const do_centered = function() {
		let columns = grid.querySelectorAll('.g-c')
		columns.forEach(c => {
			c._start = c.getBoundingClientRect().left
		})

		if (this.checked) grid.classList.add('g--centered')
		else grid.classList.remove('g--centered')

		columns.forEach(c => {
			c._end = c.getBoundingClientRect().left
		})

		columns.forEach(c => c.animate([
				{transform: `translateX(${c._start - c._end}px)`},
				{transform: 'translateX(0)'}
			], {
				duration: 250,
				easing: 'ease'
			})
		)
		make_html();
	}

	add.addEventListener('click', do_add);
	remove.addEventListener('click', do_remove);
	width.addEventListener('input', () => do_input.apply(width, [false]));
	media.addEventListener('input', do_media);

	even.addEventListener('input', ()=> (even.checked?(is_even=true,do_reset()):is_even=false));
	guttersDef.addEventListener('input', ()=> do_gutters())
	guttersSm.addEventListener('input', ()=> do_gutters('Sm'))
	guttersLg.addEventListener('input', ()=> do_gutters('Lg'))
	centered.addEventListener('input', do_centered)

	do_reset()
});

function process(str) {
	var div = document.createElement('div');
	div.innerHTML = str.trim();

	return format(div, 0).innerHTML;
}

function format(node, level) {
	var indentBefore = new Array(level++ + 1).join('  '),
		indentAfter = new Array(level - 1).join('  '),
		textNode;

	for (var i = 0; i < node.children.length; i++) {
		textNode = document.createTextNode('\n' + indentBefore);
		node.insertBefore(textNode, node.children[i]);

		format(node.children[i], level);

		if (node.lastElementChild == node.children[i]) {
			textNode = document.createTextNode('\n' + indentAfter);
			node.appendChild(textNode);
		}
	}

	return node;
}
